import React from "react";
import { cn } from "@/lib/utils";

export interface FeatureItemAddress {
  line1: string;
  line2: string;
}

interface FeatureItemProps {
  time?: string;
  title: string;
  subtitle?: string;
  description: string;
  address?: FeatureItemAddress;
  className?: string;
  isLast?: boolean;
}

export function FeatureItem({
  time,
  title,
  subtitle,
  description,
  address,
  className,
  isLast = false,
}: FeatureItemProps) {
  return (
    <div
      className={cn(
        "border-b border-gothia-gold/20 pb-4",
        isLast && "border-b-0 pb-0",
        className,
      )}>
      <div className="mb-2 text-section-title text-gothia-green">
        {title}
      </div>
      {subtitle && (
        <div className="mb-2 text-body-sm text-gray-700">{subtitle}</div>
      )}
      <div className="space-y-1 text-body text-gray-700">
        {time && (
          <div className="flex items-center gap-2">
            <svg
              className="h-4 w-4 text-gray-700"
              fill="none"
              stroke="currentColor"
              strokeWidth={1.5}
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v6l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>{time}</span>
          </div>
        )}
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <svg
              className="h-4 w-4 text-gray-700"
              fill="none"
              stroke="currentColor"
              strokeWidth={1.5}
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1114 0z"
              />
            </svg>
            <span>{description}</span>
          </div>
          {address && (address.line1 || address.line2) && (
            <div className="space-y-0">
              {address.line1 && <div className="pl-6 text-xs text-gray-600">{address.line1}</div>}
              {address.line2 && <div className="pl-6 text-xs text-gray-600">{address.line2}</div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
